/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 */
import React, { useState } from 'react';
import { Copy, HeartHandshake, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { RichText } from '@/components/common/RichText';

/** Render leggero del testo strutturato (titoli markdown, grassetti, elenchi) — componente condiviso. */
export const StructuredText = ({ text }) => (
  <RichText text={text} className="text-sm" data-testid="care-ai-family-text" />
);

/** Form per generare l'aggiornamento (note manuali o automatico dalle note del team). */
export const FamilyUpdateForm = ({ busy, onRun }) => {
  const [notes, setNotes] = useState('');
  return (
    <div className="space-y-2">
      <Label className="text-xs uppercase text-muted-foreground">Note di turno OSS (opzionale)</Label>
      <Textarea
        rows={3}
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        placeholder="Lascia vuoto per usare le note del team delle ultime 24h. Es: “Colazione metà, poca acqua, deambula con aiuto, umore buono…”"
        data-testid="care-ai-family-notes"
      />
      <div className="flex justify-end">
        <Button onClick={() => onRun({ shift_notes: notes.trim() || undefined, days: 1 })} disabled={busy} data-testid="care-ai-family-run">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <HeartHandshake className="h-4 w-4" />} Genera aggiornamento per i familiari
        </Button>
      </div>
    </div>
  );
};

export const FamilyUpdateResult = ({ result, createdAt }) => {
  if (!result?.testo) return null;
  const copy = async () => {
    try { await navigator.clipboard.writeText(result.testo); toast.success('Testo copiato'); } catch { toast.error('Copia non disponibile'); }
  };
  return (
    <div className="rounded-xl border border-border bg-secondary/30 p-4 space-y-2" data-testid="care-ai-family-result">
      <div className="flex items-center justify-between gap-2 text-[11px] text-muted-foreground">
        <span>{createdAt ? new Date(createdAt).toLocaleString('it') : ''} · fonte: {result.fonte === 'manual' ? 'note inserite' : 'note del team'}</span>
        <Button variant="ghost" size="sm" onClick={copy} className="h-7 text-xs" data-testid="care-ai-family-copy"><Copy className="h-3.5 w-3.5" /> Copia</Button>
      </div>
      <StructuredText text={result.testo} />
    </div>
  );
};
